<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import type { EChartsType } from 'echarts'
import * as echarts from 'echarts'
import { storeToRefs } from 'pinia'
import { useEventStore } from '@/stores/useEventStore'

const eventStore = useEventStore()
const { chartSeries } = storeToRefs(eventStore)
const chartRef = ref(null)
let chartInstance: EChartsType | null = null

const handleResize = () => {
  chartInstance?.resize()
}

onMounted(async () => {
  await eventStore.getEventsCharts()
  window.addEventListener('resize', handleResize)
})

watch(chartSeries, () => {
  if (chartRef.value) {
    chartInstance = echarts.init(chartRef.value)
    const option = {
      tooltip: {
        trigger: 'item',
        formatter: (params: { seriesName: string; name: string; dataIndex: number }) => {
          const t = params.seriesName.slice(-1)
          let tooltip = '<strong>' + params.name + '</strong>'

          const stackSeries = chartSeries.value.filter((s) => !s.name.includes('Tendance') && s.stack.includes(t))
          let total = 0

          for (const serie of stackSeries) {
            const value = serie.data[params.dataIndex]

            tooltip += `<div class="flex flex-row w-full justify-content-end align-items-center">
              <span class="badge badge-xs my-auto" style="background-color : ${serie.color};"></span>
              <p class="w-10 ms-2">${serie.name}</p>
              <span class="font-bold w-10 text-right">${value}</span>
              </div>`
            total += value
          }
          tooltip += `<div class="flex flex-row w-full justify-content-end align-items-center">
              <p class=" w-full ms-5">Total</p>
              <strong class="self-end">${total}</strong>
              </div>`
          return tooltip
        },
        axisPointer: {
          type: 'shadow-sm',
        },
      },
      legend: {},
      grid: {
        top: '12%',
        left: '4%',
        right: '3%',
        containLabel: true,
      },
      xAxis: [
        {
          type: 'category',
          data: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        },
      ],
      yAxis: [
        {
          type: 'value',
        },
      ],
      series: chartSeries.value,
    }

    chartInstance.setOption(option, {
      notMerge: false,
    })
  }
})
</script>
<template>
  <div class="flex justify-end w-full">
    <slot name="header"></slot>
  </div>
  <div ref="chartRef" class="w-full h-80 overflow-visible"></div>
</template>
